import { Component, computed, inject, input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ICON_PATHS } from './icon.registry';

@Component({
  selector: 'uw-icon',
  standalone: true,
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      class="block"
      fill="none"
      stroke="currentColor"
      [attr.stroke-width]="strokeWidth()"
      stroke-linecap="round"
      stroke-linejoin="round"
      [attr.aria-hidden]="true"
      [style.width]="size() + 'px'"
      [style.height]="size() + 'px'"
      [innerHTML]="paths()"
    ></svg>
  `,
  styles: `
    :host {
      display: inline-flex;
      flex-shrink: 0;
      align-items: center;
      justify-content: center;
    }
  `,
})
export class UwIcon {
  readonly name = input.required<string>();
  readonly size = input(16);
  readonly strokeWidth = input(2);

  private readonly sanitizer = inject(DomSanitizer);

  protected readonly paths = computed(() =>
    this.sanitizer.bypassSecurityTrustHtml(ICON_PATHS[this.name()] ?? ''),
  );
}
